import { FundFamilySetupTabProps } from "features/fund-family/setup/FundFamilySetupTabProps";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PageBody from "shared/components/layout/PageBody";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { PageTabs, PageTabsStatus } from "shared/components/layout/PageTabs";
import { useFeatureFlagsActive } from "shared/hooks/useFeatureFlag";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";
import { useCurrentPageTabId } from "shared/navigation/useCurrentPageTabId";

export const FundFamilySetupFundPage: React.FC = () => {
  const { t } = useTranslation(["fundFamily", "common"]);
  const navigate = useNavigate();

  const { fundFamilyId } = useRequiredStringParams();
  const tabId = useCurrentPageTabId();

  const onCancel = () => {
    navigate(rootRoute({}).fundFamilies({}).$);
  };

  const tabContext: FundFamilySetupTabProps = { fundFamilyId, onCancel };

  const featureFlags = useFeatureFlagsActive([
    "allow_creation_of_allocation_rule_graphs_via_ui",
    "use_allocation_rule_groups",
  ]);

  const isEitherFlagOn = useMemo(
    () =>
      featureFlags.get("allow_creation_of_allocation_rule_graphs_via_ui") ||
      featureFlags.get("use_allocation_rule_groups"),
    [featureFlags],
  );

  const hiddenTabs: PageTabsStatus = {
    fundFamilySetupFundAllocations: isEitherFlagOn,
  };

  return (
    <PageContent
      isFullHeight={
        tabId === "fundFamilySetupFundCalculations" ||
        tabId === "fundFamilySetupFundAllocations" ||
        tabId === "fundFamilySetupFundTransactionCodes"
      }
    >
      <PageHeader title={t("fundFamily:setup.title")} />
      <PageBody>
        <PageTabs context={tabContext} hiddenTabs={hiddenTabs} />
      </PageBody>
    </PageContent>
  );
};
